import { render, staticRenderFns } from "./reset-password-view.vue?vue&type=template&id=c62d3954&"
import script from "./reset-password-view.vue?vue&type=script&lang=js&"
export * from "./reset-password-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports